import { toast } from 'sonner';

import { useDemoRequestModal } from './states';

import { FeedbackBaseModal } from '@/components/feedback-base-modal';
import { client } from '@/client';

export const DemoRequestModal = () => {
  const modal = useDemoRequestModal();

  const handleSubmit = async ({
    text,
    isAnonymous,
  }: {
    text: string;
    isAnonymous: boolean;
  }) => {
    await client.post('/feedback/demo-request', {
      request: text,
      isAnonymous,
    });
    toast.success('Thank you for your request!');
    modal.close();
  };

  return (
    <FeedbackBaseModal
      isOpen={modal.isOpen}
      onClose={modal.close}
      onSubmit={handleSubmit}
      placeholder="Explain your request here. links are highly appreciated :)"
      submitButtonText="Send Request"
      additionalInfo={
        <p className="text-xs text-subtle-600 mb-3">
          Demo requests are super appreciated but may take some time to be
          reviewed.
        </p>
      }
    />
  );
};
